/**
 * console.log等の出力関数でよく使うものを定義しておく
 * @param obj 任意のオブジェクト
 */
export const consoleObject = (obj: any) => {
  console.log(JSON.stringify(obj, null, 2));
  // console.trace(); // どこから来てるのか欲しい時用
};
